<template>
  <div class="h-select-tags" @click.capture="$emit('click')">
    <AutocompleteSearch
      v-if="isSearch"
      :id="id"
      :placeholder="placeholder"
      :value-key="selectValueLabel"
      :search-function="options"
      :value="selectValue"
      @input="handleSelectInput"
    />
    <WAutocomplete
      v-else
      :id="id"
      v-model="selectValue"
      :name="id"
      :placeholder="placeholder"
      :search-by-key="selectValueLabel"
      :items="options"
      @w-select="handleSelectInput($event.target.value)"
    />

    <HTag
      v-for="value in values"
      :key="value[selectValueLabel]"
      color="magenta"
      size="large"
      class="h-select-tags__tag"
    >
      {{ value[selectValueLabel] }}
      <span
        :data-testid="value[selectValueLabel]"
        @click="handleClickRemove(value)"
      >
        <WIcon icon="icClose" size="medium" />
      </span>
    </HTag>
  </div>
</template>
<script>
import { WAutocomplete, WIcon } from '@alice-health/wonderland-vue'
import { nextTick } from 'vue'

import { AutocompleteSearch, HTag } from '../../atoms'
export default {
  components: { HTag, WIcon, AutocompleteSearch, WAutocomplete },
  props: {
    id: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    selectValueLabel: {
      type: String,
      required: true
    },
    options: {
      type: [Function, Array],
      required: true
    },
    values: {
      type: Array,
      default: undefined
    }
  },
  emits: ['click', 'input'],
  data() {
    return {
      selectValue: null
    }
  },
  computed: {
    isSearch() {
      return !Array.isArray(this.options)
    }
  },
  methods: {
    async handleSelectInput(value) {
      if (!value) return

      const result = !this.values ? [value] : [...this.values, value]

      this.$emit('input', result)
      nextTick(() => {
        this.selectValue = ''
      })
    },
    handleClickRemove(value) {
      const values = [...this.values]
      const index = values.findIndex(v => {
        return v[this.selectValueLabel] === value[this.selectValueLabel]
      })
      values.splice(index, 1)
      this.$emit('input', values)
    }
  }
}
</script>
<style lang="scss" scoped>
.h-select-tags {
  width: 100%;
  &__tag {
    margin-top: var(--gl-spacing-02);
    margin-right: var(--gl-spacing-02);
  }
}
</style>
